import { ApiVariableParameter } from '../../domain/remote/httpVariable/HttpVariableDomains';
import ValueFactory from '../../util/ValueFactory';
import { ReduxBaseAction } from '../../domain/redux/ReduxBaseAction';
import { ApiVariableActions } from '../actions/ApiVariableActions';
import { AuthType } from '../../components/enrichment/api/editor/auth/ApiAuthorizationComponent';
import { ApiVariable } from '../../domain/enrichment/EnrichmentDomain';
import DeploymentModel from '../../domain/stream/model/DeploymentModel';
import { ApiVariableSchema } from '../../domain/enrichment/EnrichmentSchemaDomains';

export interface ApiVariableState {
  apiVariable: ApiVariable;
  schema: DeploymentModel<ApiVariableSchema> | null;
  isUpdate: boolean;
  auth: AuthType;
  isDirty: boolean;
}

const initialState: ApiVariableState = {
  apiVariable: ValueFactory.initializeApiVariable(),
  schema: { stage: 'DRAFT' } as DeploymentModel<ApiVariableSchema>,
  isUpdate: false,
  auth: AuthType.NO_AUTH,
  isDirty: false,
};

export const apiVariableReducer = (state = initialState, action: ReduxBaseAction<any, ApiVariableActions>): ApiVariableState => {
  switch (action.type) {
    case 'CHANGE_API_VARIABLE':
      return { ...state, apiVariable: action.payload, isDirty: true };
    case 'CHANGE_API_VARIABLE_SCHEMA':
      return { ...state, schema: action.payload };
    case 'CHANGE_API_VARIABLE_IS_UPDATE':
      return { ...state, isUpdate: action.payload };
    case 'CLEAR_API_VARIABLE':
      return { ...state, apiVariable: ValueFactory.initializeApiVariable(), isUpdate: false, auth: AuthType.NO_AUTH, schema: null, isDirty: false };
    case 'CHANGE_API_VARIABLE_AUTH':
      return { ...state, auth: action.payload };
    case 'CHANGE_API_VARIABLE_URL':
      const activeParameters = action.payload.parameters.filter((item: ApiVariableParameter) => item.isActive);
      const url = action.payload.url.split('?');
      if (activeParameters != undefined && activeParameters.length > 0) {
        action.payload.url = url[0] + '?' + activeParameters.map((item: ApiVariableParameter) => item.key + '=' + item.value).join('&');
      } else {
        action.payload.url = action.payload.url.split('?')[0];
      }
      return { ...state, apiVariable: action.payload };
    case 'CHANGE_API_VARIABLE_DIRTY':
      return { ...state, isDirty: action.payload };
    default:
      return state;
  }
};
